export {
  default as patio,
  ReactComponent as Patio,
} from '@assets/icons/features-and-amenities/patio.svg'    
